module.exports = __webpack_public_path__ + "static/media/shield-check.a3de42ff.svg";